import { render, staticRenderFns } from "./le-service-privacy.vue?vue&type=template&id=15956fa4&scoped=true&"
import script from "./le-service-privacy.vue?vue&type=script&lang=js&"
export * from "./le-service-privacy.vue?vue&type=script&lang=js&"
import style0 from "./le-service-privacy.vue?vue&type=style&index=0&id=15956fa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15956fa4",
  null
  
)

export default component.exports